import React, { useState } from "react";
import TextInput from "../../input/TextField/TextInput";
import { BASE_URL } from "../../../customHooks/config";
import axios from "axios";
import { toast } from "react-toastify";
import Spinner from "../../layout/loader/Spinner";

function ForgotPassword({ setStep }) {
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(false);
  const onChange = (e) => {
    setEmail(e.target.value);
  };
  function isEmailComplete(email) {
    // Regular expression pattern for basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }
  const handleChangePassword = () => {
    if (email && isEmailComplete(email)) {
      setLoading(true);
      axios
        .post(`${BASE_URL}vendor/password_generate/`, { email: email })
        .then((res) => {
          setLoading(false);
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            // navigate("/reset-password")
          } else toast.error(res?.data?.error);
        })
        .catch((err) => {
          setLoading(false);
          // toast.error("Something went wrong");
        });
    } else toast.error("Please enter valid email");
  };

  return (
    <div className="w-8/12 mt-10">
      <div className=" mt-5">
        <TextInput label="Email Address" onChange={onChange} />
      </div>
      <div className=" mt-5">
        <button className="btn-primary" onClick={handleChangePassword}>
          {loading ? <Spinner /> : "Send mail"}
        </button>
      </div>
      <div className=" mt-5">
        <p className="text-xs text-[#64748B] text-center">
          Check spam folders if email is not in the inbox.
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
